/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button .mat-icon{font-size:18px}"];
export { styles as styles };
